import request from './request';

// 登录
export const loginApi = (data) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data,
    noTips: true,
  });
};

export const getInfo = () => {
  return request({
    url: '/system/user/getInfo',
    method: 'get',
  });
};

// 退出登录
export const logout = () => {
  return request({
    url: '/auth/logout',
    method: 'post',
  });
};

// 收藏
export const chatFavorite = (data) => {
  console.log(data, 'data');
  return request({
    url: '/mf/chat/favorite',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

// 检验账号密码
export const checkUser = (data) => {
  console.log(data, 'data');
  return request({
    url: '/mf/user/checkUser',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

// 修改心情
export const moods = (data) => {
  console.log(data, 'data');
  return request({
    url: '/mf/user/moods',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

//  上报状态
export const reSubscribe = (data) => {
  console.log(data, 'data');
  return request({
    url: '/mf/chat/reSubscribe',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

export const getOnlineStatus = (id) => {
  return request({
    url: `/dating-api/users/${id}`,
    method: 'get',
    platform: 'dating',
    noTips: true,
    headers: {
      isEncrypt: false,
      'Cache-Control': 'no-cache, no-store, must-revalidate', // 禁止缓存并要求重新验证
      Pragma: 'no-cache', // HTTP/1.0 兼容的缓存控制
      Expires: '0', // 设置为0表示立即过期
    },
  });
};

// 举报接口
export const report = (data) => {
  console.log(data, 'data');
  return request({
    url: '/mf/chat/report',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

export const getUserTokens = () => {
  return request({
    url: '/pd/user/token',
    method: 'get',
  });
};

// 获取用户名下的账号信息
export const getUserDeptTree = () => {
  return request({
    url: '/system/user/deptTree',
    method: 'get',
  });
};

// 系统账号统计收益
export const dtCommissionSysUser = (params) => {
  return request({
    url: '/mf/dtCommission/sysUser',
    method: 'get',
    params,
  });
};
// 累计收益 sysUserSummary
export const dtCommissionSysUserSummary = (params) => {
  return request({
    url: '/mf/dtCommission/sysUserSummary',
    method: 'get',
    params,
  });
};
// 系统账号明细统计收益
export const dtCommissionSysUserMember = (params) => {
  return request({
    url: '/mf/dtCommission/sysUserMember',
    method: 'get',
    params,
  });
};
// 系统账号下每个账户的收益
export const dtCommissionList = (params) => {
  return request({
    url: '/mf/dtCommission/list',
    method: 'get',
    params,
  });
};
// 系统账号下每个账户的收益统计
export const dtCommissionSummary = (params) => {
  return request({
    url: '/mf/dtCommission/summary',
    method: 'get',
    params,
  });
};
// 在线时长
export const dtOnlineMemberList = (params) => {
  return request({
    url: '/mf/dtOnline/memberList',
    method: 'get',
    params,
  });
};
// 获取累计时长
export const dtOnlineSummary = (params) => {
  return request({
    url: '/mf/dtOnline/summary',
    method: 'get',
    params,
  });
};

// 聊天时长
export const dtOnlineChatMemberList = (params) => {
  return request({
    url: '/system/dtOnlineChat/memberList',
    method: 'get',
    params,
  });
};
// 聊天消息
export const dtKpiChatMessageMemberList = (params) => {
  return request({
    url: '/system/dtKpiChatMessage/memberList',
    method: 'get',
    params,
  });
};
// 登录
export const login = (data) => {
  return request({
    url: '/mf/user/login',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};
// 登出
export const logOut = (data) => {
  return request({
    url: '/mf/user/logOut',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

// 总收益
export const dtKpiOnlineChatMessageMemberList = (params) => {
  return request({
    url: '/mf/kpiOnlineChatMessage/memberList',
    method: 'get',
    params,
  });
};

// 获取用户能否发送post
// 参数pdUserId:自己的id  userId：对方id
export const selectCanSendPost = (params, options = {}) => {
  return request({
    url: '/selectCanSendPost',
    method: 'get',
    params,
    ...options, // 支持传入 signal 等选项
  });
};
// 获取当前服务端版本
// http://127.0.0.1:19002/chat/getVersion
export const getVersion = (params) => {
  return request({
    url: '/chat/getVersion',
    method: 'get',
    params,
  });
};

// 获取自己的职业信息
export const getOccupation = (params) => {
  return request({
    url: '/statistics/getOccupation',
    method: 'get',
    params
  });
};